// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import { Loader } from "../../common/Loaders/Loader";

export const InfoBtn = ({
  text,
  loading,
  submit = null,
  className,
  style = {},
  stripeFlag = false,
  disabled = false,
  dataTestId = "",
}) => {
  return (
    <button
      className={`btn btn-info ${className}`}
      style={style}
      disabled={disabled}
      onClick={submit}
      form={stripeFlag ? "stripeForm" : ""}
      data-testid={dataTestId}
    >
      {!loading ? text : <Loader />}
    </button>
  );
};

InfoBtn.propTypes = {
  loading: PropTypes.bool,
  text: PropTypes.string,
  submit: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  stripeFlag: PropTypes.bool,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
};
